var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasAvailableLanguages
    ? _c(
        "div",
        {
          staticClass:
            "gfua-project-language-dropdown-wrapper _bgc--light _pa-2 _mb-3 _flex",
        },
        [
          _c("option-field", {
            key: _vm.selectedLanguage,
            staticClass:
              "_mt-0 _flex-basis-20 gfua-project-language-dropdown-wrapper__options",
            attrs: {
              value: _vm.selectedLanguage,
              disabled: _vm.isDisabled,
              options: _vm.availableLanguagesOptions,
              "data-qa": "project-language-dropdown",
            },
            on: { change: _vm.onChange },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }